import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface MaintenanceState {
  active: boolean;
  updatedAt?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MaintenanceModeService {
  private readonly apiUrl = '/maintenance-api';

  constructor(private http: HttpClient) {}

  getState(): Observable<MaintenanceState> {
    return this.http.get<MaintenanceState>(`${this.apiUrl}?t=${Date.now()}`);
  }

  isActive(): Observable<boolean> {
    return this.getState().pipe(
      map(state => state.active),
      catchError(() => of(true))
    );
  }

  setActive(active: boolean, adminKey: string): Observable<MaintenanceState> {
    return this.http.post<MaintenanceState>(this.apiUrl, { active, adminKey });
  }
}